import React, { useEffect, useState } from "react";
import { renderRequiredStep, handleGenerateReport } from "./helper";

const MultiSteps = ({
  step,
  setStep,
  userAddress,
  parsedQueryString,
  refCode,
  roofType,
}) => {
  const [roofData, setRoofData] = useState({});
  const [errorMessage, setErrorMessage] = useState(false);

  useEffect(() => {
    if (parsedQueryString) {
      const { email, phone, name } = parsedQueryString;
      setRoofData({
        ...roofData,
        fullName: name ? decodeURI(name) : "",
        email: email ? decodeURI(email) : "",
        phoneNumber: phone ? decodeURI(phone) : "",
      });
    }
  }, [parsedQueryString]);

  return (
    <>
      {renderRequiredStep(
        step,
        setStep,
        roofData,
        setRoofData,
        handleGenerateReport,
        userAddress,
        errorMessage,
        setErrorMessage,
        refCode,
        roofType
      )}
    </>
  );
};

export default MultiSteps;
